export default __webpack_public_path__ + "static/media/Me-documentation.a66d3ce6.md";